import { Currency } from '~/Api/Currency';
import RatesSettings from '~/Api/User/ProductGroup/ExchangeRatesSettings/RatesSettings';

export default class ExchangeRates {
	settings: RatesSettings;

	availableCurrencies: Currency[];

	constructor(settings: RatesSettings, availableCurrencies: Currency[]) {
		this.settings = settings;
		this.availableCurrencies = availableCurrencies;
	}
}
